// services/assetService.js
import axios from 'axios';
import assetApiService from './assetApiService';

export const AssetService = {
  // For simulated exchanges
  async addSimulatedAsset(exchangeId, symbol, amount) {
    try {
      const newAsset = await assetApiService.create({
        exchange_id: exchangeId,
        symbol,
        amount
      });
      return newAsset;
    } catch (error) {
      console.error('Error adding simulated asset:', error);
      throw error;
    }
  },

  // Add this method inside the AssetService object:

  // For real exchanges — futures account info
  async fetchFuturesAccount(exchange) {
    try {
      const cacheKey = `futures_${exchange.exchange_id || exchange.id}`;
      const cached = localStorage.getItem(cacheKey);
      const cacheAge = Number(localStorage.getItem(`${cacheKey}_ts`) || 0);

      // Cache for 15 seconds only (futures data is more time-sensitive)
      if (cached && Date.now() - cacheAge < 15_000) {
        return JSON.parse(cached);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASEURL}/api/futures/account`,
        {
          API: exchange.API_key,
          secret: exchange.SECRET_key,
          email: localStorage.getItem('email'),
          exchange: exchange.exchange,
          exchange_id: exchange.exchange_id || exchange.id,
        },
        {
          headers: { Authorization: localStorage.getItem('token') }
        }
      );

      localStorage.setItem(cacheKey, JSON.stringify(response.data));
      localStorage.setItem(`${cacheKey}_ts`, String(Date.now()));
      return response.data;
    } catch (error) {
      console.error('Error fetching futures account:', error);
      throw error;
    }
  },

  clearFuturesCache(exchangeId) {
    localStorage.removeItem(`futures_${exchangeId}`);
    localStorage.removeItem(`futures_${exchangeId}_ts`);
  },

 // For real exchanges
async fetchRealAssets(exchange) {
  try {
    const cachedAssets = localStorage.getItem(`assets_${exchange.id}`);
    if (cachedAssets) {
      return JSON.parse(cachedAssets);
    }
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASEURL}/api/trade`,
      {
        API: exchange.API_key,
        secret: exchange.SECRET_key,
        email: localStorage.getItem('email'),
        exchange: exchange.exchange,
        exchange_id: exchange.exchange_id,          // ✅ add this
      },
      {
        headers: { Authorization: localStorage.getItem('token') }
      }
    );

    localStorage.setItem(`assets_${exchange.id}`, JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    console.error('Error fetching real assets:', error);
    throw error;
  }
},

  async deleteAsset(assetId) {
    try {
      await assetApiService.delete(assetId);
      // Clear any cached data that might include this asset
      localStorage.removeItem(`assets_${assetId}`);
      return true;
    } catch (error) {
      console.error('Error deleting asset:', error);
      throw error;
    }
  },

  // Clear cache when needed (e.g., when manually refreshing)
  clearCache(exchangeId) {
    localStorage.removeItem(`assets_${exchangeId}`);
  }
};